import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { LivestocktypeEditService } from '../../service/livestocktype-edit/livestocktype-edit.service';

@Component({
	selector: 'app-livestocktype-edit',
	templateUrl: './livestocktype-edit.component.html',
	providers: [
		LivestocktypeEditService,
		HttpModule
	]
})
export class LivestocktypeEditComponent implements OnInit {

	private token;
	private sub: any;
	public permissoes: any[] = [];
	liveForm: FormGroup;
	ID: string;
	Tipo: string;
	UnidadeMedida: string;
	Ativo: boolean;

	constructor(fb: FormBuilder, private livestocktypeEditService: LivestocktypeEditService, private flashMessagesService: FlashMessagesService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.liveForm = fb.group({
			'ID': '',
			'Tipo': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'UnidadeMedida': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.livestocktypeEditService.loadLive(this.token, this.ID).subscribe(result => {
				var updateLive = result.Result;
				this.liveForm.setValue({
					ID: updateLive.ID,
					Tipo: updateLive.Tipo,
					UnidadeMedida: updateLive.UnidadeMedida,
					Ativo: updateLive.Ativo
				});
			})
		}, error => {
			console.log(error);
			
		});
	}

	editLive(value: any) {
		this.livestocktypeEditService.editLive(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Tipo de Pecuária editado com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/tipo-pecuaria');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/tipo-pecuaria');
	}

}



// WEBPACK FOOTER //
// ./src/app/livestocktype/component/livestocktype-edit/livestocktype-edit.component.ts